import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { Badge } from "@shared/ui/badge";
import React from "react";
import { useParams } from "react-router-dom";

const TemplateDetails = ({ data }) => {
  const { id, name } = useParams();
  const templateDetails = [
    {
      label: "Channel",
      value: data?.channelName,
    },
    {
      label: "Category",
      value: data?.categoryDisplay,
    },
    {
      label: "Segment",
      value: data?.segmentName,
    },
    {
      label: "Audience Type",
      value: data?.audienceTypeName ?? "NA",
    },
  ];
  const creationDetails = [
    {
      label: "Created By",
      value: data?.createdUserRemoteName,
    },
    {
      label: "Created On",
      value: data?.createdDate,
    },
    {
      label: "Updated By",
      value: data?.lastModifiedUserRemoteName,
    },
    {
      label: "Last Updated",
      value: data?.lastModifiedDate,
    },
  ];
  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-md font-semibold">{name}</h2>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant="info">V{data?.version}</Badge>
          <Badge>{data?.statusDisplay}</Badge>
          <Badge variant="outline">{data?.channelName}</Badge>
        </div>
      </div>
      <div className="flex gap-2 flex-wrap mt-2">
        {data?.tags && data.tags.length > 0 ? (
          data.tags.map((tag, index) => (
            <Badge key={index} variant="secondary">
              {tag}
            </Badge>
          ))
        ) : (
          <Badge variant="secondary">NA</Badge>
        )}
      </div>
      <div className="mt-4">
        <div className="border-b-2 border-gray-200"></div>
      </div>
      <div className="mt-4">
        <h3 className="text-sm font-semibold text-foreground">
          Template Details
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 gap-y-4 mt-3">
        {templateDetails.map((item) => (
          <ValueLabel key={item.label} label={item.label} value={item.value} />
        ))}
      </div>
      <div className="mt-4">
        <div className="border-b-2 border-gray-200"></div>
      </div>
      <div className="mt-4">
        <h3 className="text-sm font-semibold text-foreground">
          Creation Details
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 gap-y-4 mt-3">
        {creationDetails.map((item) => (
          <ValueLabel key={item.label} label={item.label} value={item.value} />
        ))}
      </div>
    </div>
  );
};

export default TemplateDetails;
